import { GeoLocation } from '@models/geo-location';
import { NetworkLocation } from '@models/network-location';
import { WorkOrder } from '@models/work-order';
import { ScanTypes } from './enums/meter-scan-types.enum';


export class MeterScanSummary {
  username: string;
  meterMac: string;
  scanType: keyof typeof ScanTypes;
  timestamp: number;
  uploadTimestamp: number;
  mobileDeviceGeoLocation: GeoLocation;
  serviceDate: string;
  name: string;
  displayName?: null;
  band?: string | null;
  networkLocation: NetworkLocation;
  workOrder: WorkOrder;
  scansUnavailable: boolean;
  qualityControl: string;
}

